import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import Index from "./pages/Index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Blog } from './pages/Blog';
import Personal from "./pages/Personal";
import Resources from "./pages/Resources";
import NotFound from "./pages/NotFound";
import { BlogPost } from './pages/BlogPost';
import Papershelf from '@/pages/Papershelf';
import PaperDetails from '@/pages/PaperDetails';
import Experience from "./pages/Experience";
// import Projects from "./pages/Projects";
import Skills from "./pages/Skills";
import Projects from "./pages/Projects";
import Books from "./pages/Books";
import Uses from "./pages/Uses";
import OpenSource from "./pages/OpenSource";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/uses" element={<Uses />} />
            <Route path="/opensource" element={<OpenSource />} />
            <Route path="/papershelf" element={<Papershelf />} />
            <Route path="/papers/:paperId" element={<PaperDetails />} />
            <Route path="/books" element={<Books />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            {/* <Route path="/personal" element={<Personal />} />
            <Route path="/resources" element={<Resources />} /> */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
